import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=65e98af6&lang=less&scoped=true"

import exportComponent from "/data/home/csserver/project/cpcps/h5fe_cpcps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65e98af6"]])

export default __exports__